export const environment = {
  production: false,
  // In development we will call the production API directly as requested
  xAPI_BASE_URL: 'https://func-guianoivas-dev-deczg2affxb9f7f7.brazilsouth-01.azurewebsites.net/api/v1',
  API_BASE_URL: 'https://funcguianoivasprod-e7b7atdxh8dbcnd4.brazilsouth-01.azurewebsites.net/api/v1'
};
